import { Injectable } from '@angular/core';
import { IDimension } from '../model/interface/IDimension';
import { IItem } from '../model/interface/IItem';

@Injectable({
  providedIn: 'root',
})
export class ItemService {
  private dictionaryOrderItems: any = [];

  constructor() {
    this.loadDataDictionaryOrderItems();
  }

  public getItem(numItem: number): IItem {
    const idItem = this.dictionaryOrderItems[numItem];
    const idDimension = idItem.split('', 1).toString();

    return this.getDataItems()
      .find((dimension) => {
        return dimension.id == idDimension;
      })
      .items.find((item) => {
        return item.id == idItem;
      });
  }

  private getDataItems(): IDimension[] {
    return [
      {
        id: 'E',
        name: 'Experiencia inicial',
        items: [
          {
            id: 'E1',
            question: 'Normalmente prefieres',
            answer: [
              'A. Resolver problemas de forma práctica',
              'B. Analizar y cuestionar situaciones',
            ],
          },
          {
            id: 'E2',
            question: 'Cuando inicias un proyecto prefieres',
            answer: [
              'A. Generar ideas libremente, sin una estructura formal',
              'B. Formular un plan estructurado con una finalidad clara',
            ],
          },
          {
            id: 'E3',
            question: 'Es mejor',
            answer: [
              'A. Una nueva experiencia',
              'B. Una pregunta interesante y profunda',
            ],
          },
          {
            id: 'E4',
            question: 'Para resolver un problema es mejor',
            answer: [
              'A. Actuar primero y responder dudas después',
              'B. Conocer todos los detalles antes de actuar',
            ],
          },
          {
            id: 'E5',
            question: 'Te estimula más aprender porque',
            answer: [
              'A. Puedes resolver situaciones reales',
              'B. Existen temas muy interesantes y complejos',
            ],
          },
        ],
      },
      {
        id: 'P',
        name: 'Percepción',
        items: [
          {
            id: 'P1',
            question: '¿Cuál frase te describe mejor?',
            answer: [
              'A. "Hablo conmigo mismo mientras realizo algún trabajo"',
              'B. "Hago dibujos y diagramas mientras escucho la clase"',
              'C. "Me gusta tocar, armar y desarmar las cosas"',
            ],
          },
          {
            id: 'P2',
            question: 'Si deseas aprender algo nuevo por tu cuenta, prefieres',
            answer: [
              'A. Hablar con un amigo y hacerle preguntas',
              'B. Leer acerca del tema',
              'C. Buscar material y ponerte manos a la obra',
            ],
          },
          {
            id: 'P3',
            question: '¿Cómo prefieres llegar a un sitio desconocido?',
            answer: [
              'A. Con instrucciones por teléfono',
              'B. Con un mapa dibujado en un papel',
              'C. Teniendo un punto de encuentro conocido ',
            ],
          },
          {
            id: 'P4',
            question: 'Prefieres aprender sobre un tema',
            answer: [
              'A. Escuchando a alguien ',
              'B. Usando ilustraciones y textos',
              'C. Haciendo ejercicios prácticos',
            ],
          },
          {
            id: 'P5',
            question: 'Te distrae más fácilmente',
            answer: ['A. Un ruido', 'B. Una luz', 'C. Un movimiento'],
          },
          {
            id: 'P6',
            question: 'Si deseas memorizar algo te es más fácil',
            answer: [
              'A. Escuchar una clase grabada',
              'B. Repasar visualmente un texto o ilustración',
              'C. Repetir rítmicamente en voz alta  y paso a paso una explicación',
            ],
          },
          {
            id: 'P7',
            question: 'Para encontrar una ubicación prefiero',
            answer: [
              'A. Escuchar instrucciones',
              'B. Ver un mapa',
              'C. Llegar intuitivamente',
            ],
          },
        ],
      },
      {
        id: 'Q',
        name: 'Procesamiento',
        items: [
          {
            id: 'Q1',
            question: 'Te es más fácil manipular',
            answer: ['A. Ideas abstractas', 'B. Objetos concretos'],
          },
          {
            id: 'Q2',
            question: 'Te expresas mejor',
            answer: ['A. Con palabras', 'B. Con sonidos, imágenes y/o actos'],
          },
          {
            id: 'Q3',
            question: 'Si tienes mucho por estudiar',
            answer: [
              'A. Intentas entender cada elemento uno por uno',
              'B. Intentas sintetizar y entender solo las ideas generales',
            ],
          },
          {
            id: 'Q4',
            question: 'Cuando acabas un trabajo',
            answer: [
              'A. Verificas que todo esté bien',
              'B. Confías en que el proceso estuvo bien desarrollado y lo entregas',
            ],
          },
          {
            id: 'Q5',
            question: 'Es mejor entender una idea desde',
            answer: ['A. Los detalles', 'B. Una imágen general'],
          },
          {
            id: 'Q6',
            question: 'Es más importante',
            answer: ['A. El resultado', 'B. El proceso'],
          },
          {
            id: 'Q7',
            question: 'Te resulta incómodo',
            answer: [
              'A. Las actividades abiertas y sin estructura clara',
              'B. Ceñirte a procesos muy rigurosos',
            ],
          },
        ],
      },
      {
        id: 'R',
        name: 'Planificación',
        items: [
          {
            id: 'R1',
            question: 'Realizo las tareas por orden, según su importancia.',
            answer: ['A. Casi nunca', 'B. A veces', 'C. Siempre'],
          },
          {
            id: 'R2',
            question: 'Termino mis tareas a tiempo',
            answer: ['A. Casi nunca', 'B. A veces', 'C. Siempre'],
          },
          {
            id: 'R3',
            question: 'Tengo tiempo de sobra al realizar mis tareas',
            answer: ['A. Casi nunca', 'B. A veces', 'C. Siempre'],
          },
          {
            id: 'R4',
            question:
              'Participo en reuniones sociales cuando debería estar estudiando',
            answer: ['A. Casi nunca', 'B. A veces', 'C. Siempre'],
          },
          {
            id: 'R5',
            question: 'Tengo estimado cuanto tiempo me va a llevar cada tarea',
            answer: ['A. Casi nunca', 'B. A veces', 'C. Siempre'],
          },
        ],
      },
      {
        id: 'S',
        name: 'Orientación social',
        items: [
          {
            id: 'S1',
            question: 'Prefiero',
            answer: [
              'A. Exponer ante un grupo numeroso',
              'B. Enseñar a pocas personas',
            ],
          },
          {
            id: 'S2',
            question: 'Prefiero',
            answer: [
              'A. Liderar un grupo',
              'B. Observar un grupo mientras trabaja',
            ],
          },
          {
            id: 'S3',
            question: 'Cuando no entiendo un tema',
            answer: [
              'A. Consulto a mis compañeros',
              'B. Consulto el material de estudio por mi cuenta',
            ],
          },
          {
            id: 'S4',
            question: 'Me siento es más cómodo',
            answer: ['A. Estudiar con compañeros', 'B. Estudiar por mi cuenta'],
          },
          {
            id: 'S5',
            question: 'Cuando debo trabajar en grupo',
            answer: [
              'A. No tengo problema en trabajar con personas nuevas',
              'B. Prefiero trabajar con personas conocidas',
            ],
          },
        ],
      },
      {
        id: 'U',
        name: 'Uso de los aprendido',
        items: [
          {
            id: 'U1',
            question: 'Mi conocimiento previo sirve para',
            answer: ['A. Sugerir atajos', 'B. Profundizar'],
          },
          {
            id: 'U2',
            question: 'En una discusión busco',
            answer: [
              'A. Obtener soluciones prácticas',
              'B. Conocer opiniones muy diferentes a las mías',
            ],
          },
          {
            id: 'U3',
            question: 'Con el tiempo el conocimiento',
            answer: ['A. Se  refina', 'B. Se amplía'],
          },
          {
            id: 'U4',
            question: 'Lo que he aprendido me permite ',
            answer: [
              'A. Tener herramientas que me dan ventajas prácticas',
              'B. Reflexionar mejor acerca de los acontecimientos',
            ],
          },
          {
            id: 'U5',
            question: 'Cada vez que aprendo algo nuevo',
            answer: [
              'A. Puedo intervenir de forma más eficaz',
              'B. Puedo entender mejor todo lo que ya sé',
            ],
          },
        ],
      },
    ];
  }

  private loadDataDictionaryOrderItems(): void {
    this.dictionaryOrderItems = {
      '1': 'E1',
      '2': 'E2',
      '3': 'E3',
      '4': 'E4',
      '5': 'E5',
      '6': 'P1',
      '7': 'P2',
      '8': 'P3',
      '9': 'P4',
      '10': 'P5',
      '11': 'P6',
      '12': 'P7',
      '13': 'Q1',
      '14': 'Q2',
      '15': 'Q3',
      '16': 'Q4',
      '17': 'Q5',
      '18': 'Q6',
      '19': 'Q7',
      '20': 'R1',
      '21': 'R2',
      '22': 'R3',
      '23': 'R4',
      '24': 'R5',
      '25': 'S1',
      '26': 'S2',
      '27': 'S3',
      '28': 'S4',
      '29': 'S5',
      '30': 'U1',
      '31': 'U2',
      '32': 'U3',
      '33': 'U4',
      '34': 'U5',
    };
  }
}
